<template>
  <div id="auth" class="container align-all">
    <section id="auth-content" class="box padding install">
      <h2>Convite para Acesso</h2>
      <form class="margin-top-l">
        <div class="item">
          <div class="flex between">
            <label>Nome da Conta:</label>
          </div>
          <input v-model="accname" type="text" readonly="true" disabled />
        </div>
      </form>
      <div class="margin-top-l">
        <p>Você foi convidado para ter acesso a conta informada. Basta clicar em aceitar convite para liberar acesso a conta.</p>
      </div>

      <div class="login-buttons recovery margin-top-l flex column">
        <div>
          <a @click="sendAcceptInviate()" class="button primary full">ACEITAR CONVITE</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { acceptInvite } from "@/services/auth";

export default {
  name: "invite-user",
  props: ["rtoken"],
  data() {
    return {
      accname: "",
    };
  },
  mounted() {
    const params = new URLSearchParams(window.location.search)
    this.accname = params.get('accname')
    if (this.accname) {
      this.accname = decodeURIComponent(this.accname)
    }
  },
  methods: {
    sendAcceptInviate() {
      acceptInvite({
        token: this.rtoken,
      })
        .then((response) => {
          this.$toast.success({
            title: "Sucesso",
            message: "Convite aceito com sucesso"
          });

          this.$store.dispatch("auth", { token: response.auth_token });
          this.$router.push({ name: "Account" });
        })
        .catch(error => {
          if (error && error.message === "request-canceled") {
            return;
          }

          return this.$toast.error({
            title: "Erro",
            message: "Ocorreu um erro interno"
          });
        });
    }
  }
};
</script>
